import React from "react";
import Typography from "@material-ui/core/Typography";

const Overline = (props: any) => (
  <Typography variant="overline" component="p" gutterBottom {...props} />
);

export default Overline;
